import {
  TeamOutlined,
  UserSwitchOutlined,
  UsergroupAddOutlined,
  UsergroupDeleteOutlined,
} from "@ant-design/icons";
import { Card, Col, Row, Statistic } from "antd";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import "./style.css";
import dayjs from "dayjs";

const NewDashboardCard = ({ information, selectedDates }) => {
  const startdate = selectedDates?.startdate || dayjs().format("YYYY-MM-DD");
  const enddate = selectedDates?.enddate || startdate;

  const cards = [
    {
      title: "TOTAL USERS",
      value: information?.totalUsers,
      link: "/admin/hr/staffs",
      icon: <TeamOutlined />,
      color: "#10b981",
    },
    {
      title: "TODAY PRESENT",
      value: information?.todayPresent,
      link: `/admin/hr/totalAttendance?startdate=${startdate}&enddate=${enddate}&dashboardStatus=Present`,
      icon: <UsergroupAddOutlined />,
      color: "#0891b2",
    },
    {
      title: "TODAY LEAVE",
      value: information?.todayOnLeave,
      link: `/admin/hr/totalAttendance?startdate=${startdate}&enddate=${enddate}&dashboardStatus=On Leave`,
      icon: <UserSwitchOutlined />,
      color: "#a855f7",
    },
    {
      title: "ABSENT",
      value: information?.todayAbsent,
      link: `/admin/hr/totalAttendance?startdate=${startdate}&enddate=${enddate}&dashboardStatus=Absent`,
      icon: <UsergroupDeleteOutlined />,
      color: "#f43f5e",
    },
  ];

  return (
    <Fragment>
      <section className="mt-5 mb-5">
        <div className="site-statistic-demo-card">
          <Row gutter={[16, 16]} justify="space-between">
            {cards.map((card) => (
              <Col xs={20} sm={16} md={12} lg={5} xl={5} key={card.title}>
                <Link to={card.link} aria-label={`View ${card.title.toLowerCase()}`}>
                  <Card className="ant-shadow txt-color-2" bordered={false}>
                    <Statistic
                      title={<p className="text-lg txt-color-2">{card.title}</p>}
                      loading={!information}
                      value={card.value}
                      valueStyle={{ color: card.color, fontSize: "18px" }}
                      prefix={<span className="mr-4" style={{ fontSize: "18px" }}>{card.icon}</span>}
                    />
                  </Card>
                </Link>
              </Col>
            ))}
          </Row>
        </div>
      </section>
    </Fragment>
  );
};

export default NewDashboardCard;